import { Roles } from "./roles";

export interface UserSummary {
  id: string;
  userName: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
}

export interface User {
  id: string;
  userName: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  roles: string[];
}

export interface RegisterUser {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  roles: string[];
}
export interface UpdateUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  roles: string[];
}

export interface ChangePassword {
  oldPassword: string;
  newPassword: string;
}

export interface UpdateCurrentUser {
  firstName: string;
  lastName: string;
}

export class CurrentUser {
    constructor(
      public id: string,
      public email: string,
      public firstName: string,
      public lastName: string,  
      public title: string,
      public roles: string[],
      public token: string,
      public municipalityId: string,
      public municipalityName: string,
      public associationId: string | null,
      public associationName: string | null

    ) {}

    static fromJson(data: any): CurrentUser {
      return new CurrentUser(
          data.id,
          data.email,
          data.firstName,
          data.lastName,
          data.title,
          data.roles,
          data.token,
          data.municipalityId,
          data.municipalityName,
          data.associationId ?? null,
          data.associationName ?? null
      );
  }
  
    hasRole(role: string): boolean {
      return this.roles.includes(role);
    }

    isSystemAdministrator(): boolean {
      return this.hasRole(Roles.SystemAdministrator);
    }

    isMunicipalityAdministrator(): boolean {
        return this.hasRole(Roles.MunicipalityAdministrator);
    }

    isAssociationResponsiblePerson(): boolean {
      return this.hasRole(Roles.AssociationResponsiblePerson);
    }
  }




